module.exports = __webpack_public_path__ + "static/media/Examenes.3c4d4084.svg";